import React, { Fragment } from 'react';
import { RolesPart, UserItemUp, UserName, UsersContainer } from './styles';
import Icon from 'components/Icon';
import messages from './Messages';
import { IChipItem } from 'components/SelectChips/SelectChips';
import { display } from 'components/ErrorView/ErrorDialog';
import { black, gray, stringToColour } from 'utils/style/colors';
import Badge from '../../../components/Badge';
import { IUser } from 'store/users/usersType';
import {
  ICompany,
  ICompanyMember,
  IUserRoleView,
} from 'store/companies/companiesTypes';

interface IComponentProps {
  user: IUser;
  member: ICompanyMember;
  options?: IChipItem[];
  onDelete: (userId: number, userName: string) => () => void;
  onRestore: (memberObject: ICompanyMember) => () => void;
  defaultRoles: IChipItem[];
  isCompanyOwner: boolean;
  onDeleteMemberRole: (value: IChipItem) => Promise<void>;
  onUpdateMember: (
    member: ICompanyMember
  ) => Promise<{ companyMember: ICompanyMember }>;
  onRemoveMemberSignature: (companyId: number, userId: number) => Promise<void>;
  onAddMemberRole: (
    value: string | IChipItem
  ) => Promise<{ userRoles: IUserRoleView[] }>;
  onAddMemberSignature: (
    companyId: number,
    userId: number,
    file: any
  ) => Promise<void>;
  onUserSelect: (userId: number) => any;
  onUpdatePhone: (
    userId: number,
    currentPhone: string,
    newPhone: string,
    newName: string
  ) => any;
  isActive: boolean;
  thisUserId: number;
  company: ICompany;
}

interface IComponentStates {
  loading: boolean;
  newPhone: string;
  saving?: boolean;
  newName: string;
  userUpdated?: boolean;
  editingPhone: boolean;
}

// TODO define types
class CompanyMemberView extends React.Component<
  IComponentProps,
  IComponentStates
> {
  state: IComponentStates = {
    loading: false,
    newPhone: '',
    editingPhone: false,
    newName: '',
  };

  shouldComponentUpdate(
    nextProps: IComponentProps,
    prevState: IComponentStates
  ) {
    const { member } = this.props;
    if (member.userId !== nextProps.member.userId) {
      return true;
    }
    if (member.signature !== nextProps.member.signature) {
      return true;
    }
    if (this.state.loading !== prevState.loading) {
      return true;
    }
    if (this.props.isActive !== nextProps.isActive) {
      return true;
    }
    if (this.state.editingPhone !== prevState.editingPhone) {
      return true;
    }
    if (this.state.newPhone !== prevState.newPhone) {
      return true;
    }
    if (this.state.newName !== prevState.newName) {
      return true;
    }
    if (this.state.saving !== prevState.saving) {
      return true;
    }
    return false;
  }

  handleChangeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    // const name = e.target.name ;
    const value = e.target.checked;
    this.setState({ loading: true });
    this.props
      .onUpdateMember({ ...this.props.member, admin: value })
      .then(() => this.setState({ loading: false }))
      .catch((err: any) => {
        this.setState({ loading: false });
        display(err);
      });
  };

  handleAddMemberRole = (value: string | IChipItem) => {
    this.setState({ loading: true });
    this.props.onAddMemberRole(value).then(() => {
      this.setState({ loading: false });
    });
  };

  handleDeleteMemberRole = (value: IChipItem) => {
    this.setState({ loading: true });
    this.props.onDeleteMemberRole(value).then(() => {
      this.setState({ loading: false });
    });
  };

  render() {
    const { user, member, onUserSelect, isActive } = this.props;

    const toShowRoles = Object.entries(member.roles)
      .filter(([roleId, roleInfo]) => {
        return (
          Number(roleId) === roleInfo.sourceRoleId || !roleInfo.sourceRoleId
        );
      })
      .map(([_, b]) => b);
    return (
      <Fragment>
        <UsersContainer isActive={isActive}>
          <UserItemUp onClick={() => onUserSelect(user.id)}>
            <UserName
              style={{ color: member.inactive ? gray : black }}
              onClick={() => onUserSelect(user.id)}
            >
              {member.admin ? (
                <Icon type={'chevrons-up'} title={messages.userAdmin} />
              ) : (
                <div style={{ width: '20px' }} />
              )}
              {user?.name && <span> {user.name} </span>}
              {member?.title && ` (${member.title})`}
              {member?.inactive && ` (${messages.inactive})`}
            </UserName>
            <RolesPart>
              {toShowRoles.map((it, index) => {
                return (
                  <span key={index}>
                    <Badge
                      style={{
                        marginBottom: '2px',
                        marginInlineStart: '4px',
                      }}
                      color={stringToColour(
                        this.props.company.roles[it.id].displayName!
                      )}
                    >
                      {this.props.company.roles[it.id].displayName}
                    </Badge>
                  </span>
                );
              })}
            </RolesPart>
          </UserItemUp>
        </UsersContainer>
      </Fragment>
    );
  }
}

export default CompanyMemberView;
